export default __webpack_public_path__ + "static/media/a011-fsi-05.b7c8b61b.svg";